import React from 'react';
import { TextField } from 'react-admin';

export const FakeReferenceTextField = ({ source, replaceSource, allowReplaceSource = true, ...props}) => {
	let isAllowedReplace = allowReplaceSource;
	if (typeof allowReplaceSource === 'function') {
		isAllowedReplace = allowReplaceSource(props.record, source, replaceSource);
	}

	return <TextField {...props} source={isAllowedReplace ? replaceSource : source} />
};
